import { svg } from "lit";
const icon = svg `<path d="M25.7094 21.0061L28.814 23.9248V26.0188H21.047V35.2025L20 36.2495L18.9531 35.2025V26.0188H11.186V23.9248L14.1667 21.0061V7.92697H12.2971V5.83301H27.579V7.92697H25.7094V21.0061ZM14.0791 23.9248H25.797L23.6154 21.8223V7.92697H16.2607V21.8223L14.0791 23.9248Z" fill="currentColor"/>`;
export default icon;
